import { QS_ORDER_ASC, QS_ORDER_DESC } from "constant/app";
import * as QS from "util/query-string";

/*
 * Add query string sorting to your component.
 *
 * NOTE: This exploits history reference to location. Otherwise, you must
 * pass in location to each function call.
 */
class Sorter {
  constructor(history, hiddenFields = []) {
    this._hiddenFields = hiddenFields;
    this._history = history;

    this.getTableSortOptions = this.getTableSortOptions.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
  }

  /*
   * Right now we are limited by the capability of react bootstrap table.
   * When we change this, this function will be responsible for managing
   * order params for sorting. Ideally this should be 3-state sorting:
   * asc, desc, off. Furthermore, it should include multi-sort:
   * order_by=name,-status.
   */
  _calcOrderParams(fieldName, sortOrder) {
    const prefix = sortOrder === "desc" ? QS_ORDER_DESC : QS_ORDER_ASC;

    return [prefix + fieldName];
  }

  _getLocationParams() {
    return QS.parse(this._history.location.search);
  }

  /*
   * Provide sort parameters to react bootstrap table options.
   * Note: React bootstrap table only supports single sort value.
   */
  getTableSortOptions() {
    const params = this._getLocationParams();
    let { order_by: orderBy = [] } = params;

    if (!Array.isArray(orderBy)) {
      if (typeof orderBy === "string") {
        orderBy = orderBy.split(",");
      }
    }

    const sortOpts = {};
    orderBy.some((f) => {
      const field = f.replace(QS_ORDER_DESC, "");
      if (this._hiddenFields.includes(field)) {
        return false;
      }

      sortOpts.sortName = field;
      sortOpts.sortOrder = field.length === f.length ? "asc" : "desc";
      return true;
    });

    return sortOpts;
  }

  onSortChange(sortName, sortOrder) {
    const { pathname } = this._history.location;
    const params = this._getLocationParams();

    params.order_by = this._calcOrderParams(sortName, sortOrder);

    this._history.push({ pathname, search: QS.stringify(params) });
  }
}

export { Sorter };
